import { goToNews } from '@/app/routing/events'
import { useStyles } from './styles'
import { Glow } from '@/shared/ui/glow'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const CargoCaseNews = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.main.arrival
  return (
    <div
      className={classes.root}
      onClick={() => goToNews({ variant: 'secondary' })}
    >
      <Glow
        width={100}
        aspectRatio={'1/1'}
        filter="blur(45px)"
        top={'-45%'}
        left={0}
        background={'#2990FF'}
      />
      <Glow
        width={100}
        aspectRatio={'1/1'}
        filter="blur(30px)"
        top={'70%'}
        left={0}
        background={'#2990FF'}
      />
      <Glow
        width={50}
        aspectRatio={'1/1'}
        filter="blur(30px)"
        top={'72%'}
        left={120}
        background={'#2990FF'}
      />
      <Glow
        width={200}
        aspectRatio={'1/1'}
        filter="blur(30px)"
        top={'40%'}
        left={'70%'}
        background={'#2990FF'}
      />
      <div className={classes.textWrapper}>
        <div className={classes.arrivalContainer}>{text}</div>
        <div>
          <h1>CARGO</h1>
          <h2>Case</h2>
        </div>
      </div>
      <img
        src="/assets/backgrounds/plentyOfTokens.webp"
        alt=""
        className={classes.backTokensImg}
      />
      <img
        src="/assets/lootBoxRelated/boxes/7Box.webp"
        alt=""
        className={classes.cargoImg}
      />
      <img
        src="/assets/backgrounds/plentyOfTokens.webp"
        alt=""
        className={classes.frontTokensImg}
      />
    </div>
  )
}
